/* content file: replace all html between <> </> with actual content */

export const AwardOpensource = () => { 
  return (
  <>
    <p>
      Der Open Source Wettbewerb zeichnet wegweisende Open-Source-Anwendungen der öffentlichen Verwaltung auf Bundes-, Landes- und kommunaler Ebene aus. GA-Lotse gehörte zu den Gewinnern in der Kategorie „Fachverfahren“. Die Auszeichnung wurde im Rahmen der Smart Country Convention in Berlin verliehen.
    </p>
  </>    
  )
}